import { useLocation, useParams } from 'react-router'
import FeedbackPopup from '../../feedbacks/components/FeedbackPopup'
import BackToTopButton from './BackToTopButton'
import FloatingSliderDiamondSponsors from '../../sponsors/components/FloatingSliderDiamondSponsors'

export default function FloatingButtons() {
  const { lng } = useParams()
  const location = useLocation() // Get current path dynamically

  return (
    <>
      {/* FeedbackPopup: Only show when not on /ar/feedbacks */}
      {location.pathname !== `/${lng}/feedbacks` && <FeedbackPopup />}

      {location.pathname !== `/${lng}/home` && (
        <div className="fixed bottom-32 right-4 z-10">
          <FloatingSliderDiamondSponsors />
        </div>
      )}

      <div className="fixed bottom-12 right-2 z-10">
        <BackToTopButton />
      </div>
    </>
  )
}
